module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAClSURBVDiN7dGxDYMwEIXhv0iZARiBkgFSpGSAlCkpKVwwAGUkGm/AAGEMdmEASgpSxEhXJHfGdFGe5MZ6/u4kwz+AB1xELweewFkrXYE1HA3NgSn0vDXZGajERmtDC03CNLRNxTS0TsW2dB/Q5FyAWYCH0BuwBGQAmiOoE5gHTuJ+N/oQj5ovw6LRPhQX4K70otGK9yeU1mSBmltmEdiWYkf3V/MCqhA95RO8or8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping/Frame 62.png
// module id = 8opg
// module chunks = 8